/** Based on internal helper function from TurfJS (MIT License - inRing from https://github.com/Turfjs/turf/blob/master/packages/turf-boolean-point-in-polygon/index.ts).
    @param {Array<number>} vertex [x,y]
    @param {Array<Array<number>>} ring [[x,y], [x,y],..]
    @returns {boolean} inRing */
export const isVertexInRing = (vertex, ring) => {
  let isInside = false;
  ring = ring.slice(0, ring.length - 1); // Lop off closing vertex.
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const xi = ring[i][0], yi = ring[i][1];
    const xj = ring[j][0], yj = ring[j][1];
    const onBoundary = (vertex[1] * (xi - xj) + yi * (xj - vertex[0]) + yj * (vertex[0] - xi) === 0)
      && ((xi - vertex[0]) * (xj - vertex[0]) <= 0) && ((yi - vertex[1]) * (yj - vertex[1]) <= 0);
    if (onBoundary) { return true; }
    const intersect = ((yi > vertex[1]) !== (yj > vertex[1]))
      && (vertex[0] < (xj - xi) * (vertex[1] - yi) / (yj - yi) + xi);
    if (intersect) { isInside = !isInside; }
  }
  return isInside;
};

/** Are all the vertexes of an inner ring inside of the shape defined by an outer ring? */
export const ringContainsAllVertexes = (containerRing, innerRing) => {
  return !innerRing.some((vertex, vertexI) => {
    if (vertexI === 0) { return false; } // Skip first vertex, because it's identical with last closing vertex.
    return !isVertexInRing(vertex, containerRing);
  });
};

/** Are any of the vertexes of an inner ring inside of the shape defined by an outer ring? */
export const ringContainsAnyVertexes = (containerRing, innerRing) => {
  return innerRing.some((vertex, vertexI) => {
    if (vertexI === 0) { return false; } // Skip first vertex, because it's identical with last closing vertex.
    return isVertexInRing(vertex, containerRing);
  });
};
